import MicroModal from 'micromodal';
import initSecuritySystemFinder from './components/security-system-finder';
import triggerEventTracking from './components/analytics/cta-events';

function triggerIframeAction(action) {
    const video = document.querySelector('.modal-youtube-video .rll-youtube-player iframe');
    if (video && video.contentWindow) {
        video.contentWindow.postMessage('{"event":"command", "func":"'+action+'", "args":""}', '*');
    }
}

MicroModal.init({
    disableFocus: true,
    onShow: function (modal, element, event) {
        event.preventDefault();
        const button = document.querySelector('.modal-youtube-video .rll-youtube-player').firstChild;
        if (typeof button !== 'undefined' && button !== null) {
            button.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();
                triggerIframeAction('playVideo');
            });
            button.click();
        }
    },
    onClose: function (modal, element, event) {
        event.preventDefault();
        triggerIframeAction('pauseVideo');
    },
});

initSecuritySystemFinder();
triggerEventTracking();